import React, { Component } from 'react';
import Axios from 'axios';
import './ControlPanel.css';

import Config from '../../../base/config/Config';
import Session from '../../../base/Session';
import Utils from '../../../base/Utils';

import Title from './../../components/title/Title';
import Description from './../../components/description/Description';
import RequestLimits from './../../components/requestLimits/RequestLimits';
import ProgressBar from './../../components/progressBar/ProgressBar';
import Table from './../../components/table/Table';
import ProfilePic from './../../components/profilePic/ProfilePic';
import NetworkLogo from './../../components/networkLogo/NetworkLogo';
import Label from './../../components/label/Label';
import Button from './../../components/button/Button';
import Loading from './../../components/loading/Loading';
//import SmallText from './../../components/smallText/SmallText';

class ControlPanel extends Component {
    constructor(props) {
        super(props);
        
        Session.setCallback(() => this.checkAPIStatus());
        
        this.loadProfilesList();
        
        this.state = {
            apiStatus: Session.getParams().apiStatus,
            expireDate: Session.getParams().expireDate,
            requestLimits: null,
            profilesList: null
        };
    }
    
    render() {
        var apiStatus = this.state.apiStatus;
        var expireDate = this.state.expireDate;
        var requestLimits = this.state.requestLimits;
        
        var profilesList = this.state.profilesList;
        
        if(profilesList !== null) {
            profilesList = {body: []};
            profilesList.body.push(this.state.profilesList.map((profile) => {
                var result = [
                    { content: <ProfilePic src={profile.picture} insideComponent={<NetworkLogo network={profile.network} size="Small" />} 
                    size="Medium" />, align: 'left' },
                    { content: profile.name, align: 'left' }, //<font>Ricardo Carvalho <SmallText text="@ricardo" /></font>
                    { content: <NetworkLogo network={profile.network} size="Small" type="Name" /> }
                ];
                
                if(profile.isOutDated) {
                    result.push({ content: <Label text="DISCONNECTED" type="Bad" />, align: 'right' })
                    result.push({ content: <Button text="Reconnect" type="Clean Normal" size="Small" to={Config.mainHost + "#/manage_social_networks"} /> });
                }else{
                    result.push({ content: <Label text="CONNECTED" type="Good" />, align: 'right' });
                    result.push({ content: '' });
                }
                
                return result;
            }));
            
            if(profilesList.body[0][0]) profilesList.body = profilesList.body[0];
        }
        
        var data = Utils.getAPIStatusLayout(apiStatus);
        
        var apiStatusText = data.text;
        var apiStatusColor = data.color;
        
        return <div className="WidthLimit">
        <div className="Column-D3">
        <Title text="API State" type="Underlined" size="Big" />
        <br /><br />
        {(apiStatus === null) ? <Loading size="Medium" /> : <Title text={apiStatusText} color={apiStatusColor} size="Big" />}
        </div>
        <div className="Column-D1_5">
        <Title text="API Information" type="Underlined" size="Big" />
        <div className="Column-D2 NoMargin">
        <RequestLimits callback={(limits) => this.setRequestLimits(limits)}/>
        </div>
        <div className="Column-D2 NoMargin">
        {(expireDate === null) ? <Loading size="Medium" /> : <Description 
        text={<font>Renovates {Utils.convertDate(expireDate)}</font>} weight="Bold" align="Right" />}
        </div>
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1">
        <Title text="API Usage" type="Underlined" size="Big" />
        <div className="Column-D1 NoMargin">
        <br />
        {(requestLimits === null) ? 
            <span><br /><Loading size="Medium" type="Fill" /></span>
            : 
            <ProgressBar value={requestLimits.usage} limit={requestLimits.month} showHeader={true} />
        }
        </div>
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1">
        <Title text="Profiles" type="Underlined" size="Big" />
        <Description text="Here you can check if your profiles have any problem within their authentication or not. 
        If you are experiencing any errors with some profiles via API check their status in the table bellow." />
        <div className="Column-D1 NoMargin" style={{textAlign:'center'}}>
        {(profilesList === null) ? 
            <span><br /><br /><Loading size="Medium" type="Fill" /></span> 
            : 
            <span>{(profilesList.body.length > 0 && profilesList.body[0].length > 0) ? 
                <Table data={profilesList} /> 
                : 
                <span><br /><br /><Title text="There are no outdated profiles" type="Normal" size="Small" /></span>
            }</span>
        }
        </div>
        </div>
        <div className="Spacer"></div>
        <div className="Spacer"></div>
        <div className="Spacer"></div>
        </div>;
    }
    
    checkAPIStatus() {
        this.setState({
            apiStatus: Session.getParams().apiStatus,
            expireDate: Session.getParams().expireDate
        });
    }
    
    setRequestLimits(limits) {
        this.setState({requestLimits: limits});
    }
    
    loadProfilesList() {
        Axios.get(Config.backendHost + "manage/profiles", {withCredentials: true}).then((response) => {
            if(Utils.checkResponse(response)) {
                var data = response.data;
                
                if(data.status === 'success') {
                    data = data.data;
                    
                    this.setState({profilesList: data});
                    return;
                }
            }
            this.setState({profilesList: []});
        }).catch((err) => { this.setState({profilesList: []}); });
    }
}

export default ControlPanel;
